module.exports = __webpack_public_path__ + "static/media/image21.d01870ba.png";